goog.provide("shadow.js.shim.module$prismjs");
goog.provide("module$shadow_js_shim_module$prismjs");
shadow.js.shim.module$prismjs = shadow.js.nativeProvides["prismjs"] = shadow$bridge("prismjs");
module$shadow_js_shim_module$prismjs.default = shadow.js.shim.module$prismjs;
